import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
	ArrowRightIcon,
	LogoIconMyWay,
	MplButton,
	PASSENGER_ANDROID_LINK,
	PASSENGER_IOS_LINK,
	ProfileIcon,
	StoreBadges,
} from '@mopla/ui';
import { MoplaLogo } from '@mopla/ui/icons/MoplaLogo';

import '@mobiscroll/react/dist/css/mobiscroll.scss';

import { IMarketingFlowProps } from '../../organisms/MarketingBlock/DTicketMarketingItem';
import { MarketingBlock } from '../../organisms/MarketingBlock/MarketingBlock';

import {
	Content,
	FlexibleWrapper,
	FlexibleWrapperContent,
	HeaderBlock,
	Root,
} from './MarketingFlow.styles';
import { SubscriptionFlowWrapper } from './SubscriptionFlowWrapper';

export const MarketingFlow: FC<IMarketingFlowProps> = ({ type }) => {
	const navigate = useNavigate();
	const { t } = useTranslation(['dticket']);
	const handleLoginClick = () =>
		navigate({ pathname: '/welcome', search: 'login' });

	const handleQuickLogin = () => navigate('/welcome');

	return (
		<Root>
			<HeaderBlock>
				{type === 'dticket' ? <MoplaLogo /> : <LogoIconMyWay />}

				<div>
					<MplButton
						fullWidth
						endIcon={<ProfileIcon />}
						variant="text"
						onClick={handleLoginClick}
					>
						{t('button.login')}
					</MplButton>
				</div>
			</HeaderBlock>
			{/* TODO: this is a temporary quick fix of login; remove it later; */}
			<Content>
				<MarketingBlock type={type} />
				<FlexibleWrapper>
					<FlexibleWrapperContent>
						<StoreBadges
							iosLink={PASSENGER_IOS_LINK}
							androidLink={PASSENGER_ANDROID_LINK}
						/>
						<MplButton
							fullWidth
							variant="outlined"
							onClick={handleQuickLogin}
							endIcon={<ArrowRightIcon />}
						>
							{t('button.to_web_app')}
						</MplButton>
					</FlexibleWrapperContent>
				</FlexibleWrapper>
			</Content>
			<SubscriptionFlowWrapper />
		</Root>
	);
};
